// TELV1-554 — single frontend source for the upload size cap, shared by the
// chat file-answer input and the dashboard stimuli uploader. Keep in sync
// with the backend's ALLOWED_FILE_SIZE_TO_UPLOAD
// (backend/libs/common/src/media/multer/multer.constants.ts) — the two
// package trees share no build, so the value is duplicated across that one
// boundary by design.
export const MAX_UPLOAD_FILE_SIZE_BYTES = 200 * 1024 * 1024; // 200MB
